import { ZipCodeBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useExperienceAddressZipCode } from '../../../../fields/ExperienceFields';

interface ExperienceZipCodeProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
    isReview?: boolean;
    validator?: React.ReactNode;
}

export const ExperienceZipCode: React.FC<ExperienceZipCodeProps> = ({
    experienceId,
    required = false,
    readOnly = false,
    validator,
}) => {
    const mobileScreen = isMobileScreen();
    const label = 'Zip Code ';
    const [zipCode, set_zipCode] = useExperienceAddressZipCode(experienceId);
    return (
        <>
            <ZipCodeBox
                id='experienceZipCode'
                value={zipCode}
                onChange={(value) => set_zipCode(value)}
                label={label}
                placeholder='01234'
                required={required}
                readOnly={readOnly}
                width={mobileScreen ? '100%' : '120px'}
                validator={validator}
            />
        </>
    );
};
